export enum ApplicationState {
  Undefined = "Undefined",
  Announced = "Announced",
  Pending = "Pending",
  Signed = "Signed",
  Rejected = "Rejected",
}

export interface ApplicationStateIndexable {
  [key: string]: ApplicationState;
}

export const ApplicationStateByString: ApplicationStateIndexable = {
  Undefined: ApplicationState.Undefined,
  Announced: ApplicationState.Announced,
  Pending: ApplicationState.Pending,
  Signed: ApplicationState.Signed,
  Rejected: ApplicationState.Rejected,
};
